import React, { useState, useEffect } from "react";
import { Button, DatePicker, Pagination } from "antd";
import * as Icon from "react-feather";
import { useHistory } from "react-router-dom";
import { api_srv } from "services";
import { useQuery } from "react-query";
import moment from "moment";
import { format } from "date-fns";

export default function Renewals() {
  const [current, setCurrent] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [milestone, setMilestone]= useState("")
  const history = useHistory();




  const fetchRenewals = async () => {
    const api = await api_srv;
  
    // If milestone is selected
    if (milestone) {
      const resp = await api.fetchRenewalsMilestone(milestone);
      return resp.data || [];
    }
  
    
    if (!startDate || !endDate) return [];
  
    const formattedValues = {
      startDate: startDate ? startDate.format("YYYY-MM-DD") : null,
      endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
    };
  
    const resp = await api.fetchRenewals(formattedValues);
    return resp.data || [];
  };
  
  const {
    data: renewals = [],
    isLoading: isRenewalsLoading,
    refetch,
  } = useQuery(
    ["renewals", milestone, startDate?.toISOString(), endDate?.toISOString()],
    fetchRenewals,
    {
      enabled: Boolean(milestone || (startDate && endDate)),
      keepPreviousData: true,
    }
  );

  // Fetch renewal summary
  const fetch_renewal_summary = async () => {
    try {
      const resp = await (await api_srv).fetchRenewalSummary();
      const data = resp?.data;

      // Always return an array
      if (Array.isArray(data)) return data;
      if (typeof data === "object" && data !== null) return Object.values(data).flat();
      return [];
    } catch (err) {
      console.error("Failed to fetch renewal summary:", err);
      return [];
    }
  };

  const { data: renewalSummary = [], isLoading: isSummaryLoading } = useQuery(
    "renewalsummary",
    fetch_renewal_summary,
    { refetchOnWindowFocus: false }
  );

  // Date formatting utility
  const formatDate = (dateInput, formatString = "dd-MM-yyyy") => {
    try {
      const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
      if (isNaN(date.getTime())) return "Invalid Date";
      return format(date, formatString);
    } catch {
      return "Invalid Date";
    }
  };

  // Handle card click to filter by days
  const handleSummaryCardClick = (days, name) => {
    const today = moment().startOf("day");
    let start, end;

    if (days === 0) {
      start = today.clone();
      end = today.clone().endOf("day");
    } else {
      start = today.clone();
      end = today.clone().add(days, "days").endOf("day");
    }

    setStartDate(start);
    setEndDate(end);
  };

  // Reset date filters
  const resetFilters = () => {
    setStartDate(null);
    setEndDate(null);
  };

  // Disable future dates & enforce start <= end
  const disabledStartDate = (current) => {
    if (!current) return false;
    if (current > moment().endOf("day")) return true;
    if (endDate) return current > endDate.endOf("day");
    return false;
  };

  const disabledEndDate = (current) => {
    if (!current) return false;
    if (current > moment().endOf("day")) return true;
    if (startDate) return current < startDate.startOf("day");
    return false;
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && date && endDate.isBefore(date, "day")) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleMilestoneChange = (milestone) =>{
    setMilestone(milestone)
  }

  const onPageChange = (page) => setCurrent(page);

  // Refetch when dates change
  useEffect(() => {
    if (startDate && endDate) {
      refetch();
    }
  }, [startDate, endDate, refetch]);

  console.log("===renewal summary===", renewalSummary)

  return (
    <>
      <div className="pageheader pd-t-25 pd-b-35">
        <div className="breadcrumb pd-0 mg-0">
          <a className="breadcrumb-item" href="index.html">
            <i className="icon ion-ios-home-outline" /> Home
          </a>
          <a className="breadcrumb-item active" href>
            Dashboard
          </a>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="row row-xs clearfix mx-2">
        {isSummaryLoading ? (
          <div className="col-12 text-center py-3">Loading summary...</div>
        ) : Array.isArray(renewalSummary) && renewalSummary.length > 0 ? (
          renewalSummary.map((obj, index) => (
            <div className="col-12 col-md-3 col-xl-3" key={obj.name || index}>
              <div
                className="card mg-b-20 card-custom cursor-pointer"
                style={{
                  background: "#003049",
                  border: "none",
                  borderRadius: "4px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  transition: "transform 0.2s",
                }}
                // onClick={() => handleSummaryCardClick(obj.days, obj.name)}
                onClick={()=>handleMilestoneChange(obj.value)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                      marginBottom: "8px",
                    }}
                  >
                    <span
                      className="text-white mb-0"
                      style={{
                        fontSize: "1.175em",
                        color: "#f2f2f2",
                        fontWeight: "bold",
                      }}
                    >
                      {obj.name}
                    </span>
                    <div
                      className="card-icon"
                      style={{
                        width: "20px",
                        height: "20px",
                        background: "#f2f2f2",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon.RefreshCw size={14} color="#003049" />
                    </div>
                  </div>
                  <h2
                    className="text-white mb-1"
                    style={{ fontSize: "24px", color: "#f2f2f2" }}
                  >
                    {typeof obj.total === "number" && obj.total > 1000
                      ? `KSH ${obj.total.toLocaleString()}`
                      : obj.total}{" "}
                    <span style={{ color: "#28A745", fontSize: "10px" }}>(+29%)</span>
                  </h2>
                  <p
                    className="text-white mb-0"
                    style={{
                      fontSize: "0.875em",
                      fontWeight: "bold",
                      color: "#f2f2f2",
                    }}
                  >
                    Total
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center text-muted py-3">
            No renewal summary available
          </div>
        )}
      </div>

      {/* Main Table Card */}
      <div className="col-lg-12 col-xl-12">
        <div
          className="card mg-b-20"
          style={{
            borderRadius: "12px",
            background: "#ffffff",
            padding: "2rem",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <div className="card-header d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
            <h1 className="tx-20 mg-b-0 d-flex align-items-center">
              <Icon.RefreshCcw size={34} className="pr-2 text-primary" />
              Renewals
            </h1>

            <div className="d-flex align-items-center gap-2 flex-wrap">
              <DatePicker
                placeholder="Start Date"
                value={startDate}
                onChange={handleStartDateChange}
                disabledDate={disabledStartDate}
                format="DD MMM YYYY"
                style={{ width: 160 }}
                allowClear
              />
              <span className="tx-gray-600 font-weight-medium">to</span>
              <DatePicker
                placeholder="End Date"
                value={endDate}
                onChange={handleEndDateChange}
                disabledDate={disabledEndDate}
                format="DD MMM YYYY"
                style={{ width: 160 }}
                allowClear
              />
              {(startDate || endDate) && (
                <Button size="small" onClick={resetFilters}>
                  Clear
                </Button>
              )}
            </div>
          </div>

          <div className="card-body pd-0">
            <div className="table-responsive">
              <table className="table table-hover mg-0">
                <thead className="tx-dark tx-uppercase tx-12 tx-bold">
                  <tr className="bg-light">
                    <th className="pl-5">Client Name</th>
                    <th>Cover Start Date</th>
                    <th>Cover End Date</th>
                    {/* <th>Status</th> */}
                    <th>Reg No</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isRenewalsLoading ? (
                    <tr>
                      <td colSpan={6} className="text-center py-4">
                        Loading renewals...
                      </td>
                    </tr>
                  ) : renewals.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-4 text-muted">
                        No renewals found for selected date range.
                      </td>
                    </tr>
                  ) : (
                    renewals.map((row, index) => (
                      <tr key={row.id || index}>
                        <td className="d-flex align-items-center">
                          <div className="avatar mr-2">
                            <img
                              src="https://via.placeholder.com/100x100"
                              className="img-fluid rounded-circle"
                              alt="client"
                            />
                          </div>
                          <div>
                            <a href="#" className="my-0 mt-1 tx-semibold">
                              {row.client_details?.[0]
                                ? `${row.client_details[0].names?.firstName} ${row.client_details[0].names?.lastName}`
                                : "Unknown Client"}
                            </a>
                          </div>
                        </td>
                        <td>{formatDate(row.policyCover?.startDate)}</td>
                        <td>{formatDate(row.policyCover?.endDate)}</td>
                        {/* <td>
                          <span
                            className={`badge ${
                              row.policyStatus === "pending"
                                ? "badge-warning"
                                : row.policyStatus === "ACTIVE"
                                ? "badge-success"
                                : "badge-danger"
                            } tx-uppercase`}
                          >
                            {row.policyStatus || "Unknown"}
                          </span>
                        </td> */}
                        <td>{row.risks?.[0]?.riskRef || "-"}</td>
                        <td>
                          <div className="dropdown">
                            <a
                              href="#"
                              data-toggle="dropdown"
                              className="btn btn-sm btn-label-primary"
                            >
                              <Icon.MoreHorizontal />
                            </a>
                            <ul className="dropdown-menu dropdown-menu-left">
                              <li className="dropdown-item">
                                <a
                                  className="dropdown-link tx-13 tx-gray-500 d-flex align-items-center"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    history.push(`/dashboard/reports/renewals/${row.id}`);
                                  }}
                                >
                                  <Icon.FileText size={14} className="mr-2" />
                                  View Details
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="card-footer bg-transparent text-center">
            <Pagination
              current={current}
              onChange={onPageChange}
              total={renewals.length > 0 ? Math.ceil(renewals.length / 20) * 20 : 20}
              pageSize={20}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${renewals.length} items`}
              responsive
            />
          </div>
        </div>
      </div>
    </>
  );
}